"use client";

import React, { useState } from "react";
import { TabItem } from "./types";

interface AlertsHeaderProps {
  initialActiveTab?: string;
  onTabChange?: (tabId: string) => void;
}

export const AlertsHeader: React.FC<AlertsHeaderProps> = ({ initialActiveTab = "all", onTabChange }) => {
  const [activeTab, setActiveTab] = useState(initialActiveTab);

  const tabs: TabItem[] = [
    { id: "all", label: "All" },
    { id: "unread", label: "Unread" },
    { id: "leaks", label: "Leaks" },
    { id: "highUsage", label: "High Usage" }
  ];

  return (
    <section className="w-full font-semibold min-h-[92px]">
      <div className="px-4 w-full">
        <div className="w-full">
          <div className="flex flex-col justify-center w-full">
            <h1 className="w-full text-2xl leading-none text-gray-900">
              Alerts Centre
            </h1>
            <nav className="flex gap-1 justify-center items-center p-1 mt-4 w-full text-sm leading-none text-gray-500 bg-gray-50 rounded-xl border border-gray-200 border-solid">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => {
                    setActiveTab(tab.id);
                    onTabChange && onTabChange(tab.id);
                  }}
                  className={`overflow-hidden flex-1 shrink gap-2 self-stretch px-3 py-2 my-auto whitespace-nowrap rounded-md basis-0 min-h-9 ${
                    activeTab === tab.id
                      ? "bg-white text-slate-700 shadow"
                      : "text-gray-500"
                  }`}
                  aria-pressed={activeTab === tab.id}
                >
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>
        </div>
      </div>
    </section>
  );
};
